import type { RunState } from '~/types/game'

/** Small, discrete talent progress only: no mission clocks or animation state.
 * Vue tracks these fields directly, so timer ticks do not reevaluate this.
 * Equal-size rerolls and limited-use effects must checkpoint immediately. */
export function starweaveProgressSignature(run: RunState): string {
  if (!run.starweave) return ''
  return [
    JSON.stringify(run.starweave),
    run.draft?.bonusOptions.join(',') ?? '',
    run.pendingRewards?.map(offer => `${offer.id}:${offer.defId}`).join(',') ?? '',
    run.encounter?.missions.filter(mission => mission.training)
      .map(mission => `${mission.id}:${mission.trainingOptions?.join(',')}:${mission.trainingChoice ?? ''}`).join(';') ?? '',
  ].join('|')
}
